import { Reducer } from 'redux';
import { ValuesPurchaseRequest } from '../../models/purchase/values-purchase-request.model';
import { COLLABORATOR_LIST, COLLABORATOR_LIST_ERROR, COLLABORATOR_LIST_SUCCESS, COLLABORATOR_LIST_VALUES, COLLABORATOR_LIST_VALUES_ERROR, COLLABORATOR_LIST_VALUES_SUCCESS, EDIT_COLLABORATOR_VALUE, EDIT_COLLABORATOR_VALUE_ERROR, EDIT_COLLABORATOR_VALUE_SUCCESS, RESET_PURCHASE_COLLABORATOR, RESET_PURCHASE_COLLABORATOR_ERROR, RESET_PURCHASE_COLLABORATOR_SUCCESS, SUMMARY_OLD_VALUE_REBALANCE } from '../contants';

type CollaboratorInitStateType = {
    collaborators: any;
    editedCollaborators: any | ValuesPurchaseRequest;
    oldValue: number;
    response: boolean;
    loading: boolean;
    error: boolean;
    errorMessage: string;
}

const INIT_STATE = {
    collaborators: [],
    editedCollaborators: { purchaseId: null, products: []},
    oldValue: null,
    response: false,
    loading: false,
    error: false,
    errorMessage: '',
};

const CollaboratorReducer: Reducer<CollaboratorInitStateType> = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case RESET_PURCHASE_COLLABORATOR:
      return { ...state, loading: true, error: false };
    case RESET_PURCHASE_COLLABORATOR_SUCCESS:
      return {
        ...state,
        collaborators: [],
        editedCollaborators: { purchaseId: null, products: []},
        oldValue: null,
        loading: false,
        error: true,
      }
    case RESET_PURCHASE_COLLABORATOR_ERROR:
      return {
        ...state,
        collaborators: [],
        editedCollaborators: { purchaseId: null, products: []},
        oldValue: null,
        loading: false,
        error: true
      }
    case COLLABORATOR_LIST:
      return { ...state, loading: true, error: false };
    case COLLABORATOR_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            collaborators: action.payload,
            error: false,
        };
    case COLLABORATOR_LIST_ERROR:
        return {
            ...state,
            loading: false,
            collaborators: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case COLLABORATOR_LIST_VALUES:
      return { ...state, loading: true, error: false };
    case COLLABORATOR_LIST_VALUES_SUCCESS:
        return {
            ...state,
            loading: false,
            collaborators: action.payload.collaboratorValues,
            oldValue: action.payload.oldValue,
            error: false,
        };
    case COLLABORATOR_LIST_VALUES_ERROR:
        return {
            ...state,
            loading: false,
            collaborators: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case EDIT_COLLABORATOR_VALUE:
        return { ...state, loading: false, error: false };
    case EDIT_COLLABORATOR_VALUE_SUCCESS:
        return {
            ...state,
            loading: false,
            collaborators: action.payload.collaborators,
            editedCollaborators: action.payload.editedCollaborators,
            error: false,
        };
    case EDIT_COLLABORATOR_VALUE_ERROR:
        return {
            ...state,
            loading: false,
            collaborators: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case SUMMARY_OLD_VALUE_REBALANCE:
        return {
            ...state,
           oldValue: action.payload.newOldValue,
        };
    default:
      return { ...state };
  }
};

export default CollaboratorReducer;
